import React from "react"
import CustomTable from "../../components/CustomTable";
import { addLanguageName, editLanguageName, getAllLanguages, languagesUpdateApprovedAndUnapproved } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
import { AddButton } from "../../components/masterDataForm/AddButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddMasterDataWithCountryCode from "../../components/masterDataForm/AddMasterDataWithCountryCode";
import EditMasterFormWithCountryCode from "../../components/masterDataForm/EditMasterFormWithCountryCode";
const Languages = () => {

    const dispatch = useDispatch();
    const languagesInfo = useSelector(state => state?.getAllLanguages?.languages);

    const [showAddLanguages, setAddLanguagesShow] = React.useState(false);
    const [showLanguages, setLanguagesShow] = React.useState(false);
    const [languagesValName, setLanguagesValName] = React.useState();


    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllLanguages();
                dispatch({ type: 'GET_ALL_LANGUAGES', payload: res?.data?.data})
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);

    const addLanguageHandle = async (languageName) => {
        try {
            const addLanguageNames = await addLanguageName(languageName);
            if(addLanguageNames.status === 200) {
                dispatch({ type: 'ADD_LANGUAGES_NAME', payload: addLanguageNames.data?.data})
                toast.success(addLanguageNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const editLanguagesHandle = async (languages) => {
        try {
            const languagesPayload = {
                languageId: languages?.statusId,
                name: languages?.name,
                isoCode: languages?.isoCode
            }
            const editLanguagesNames = await editLanguageName(languagesPayload);
            if(editLanguagesNames.status === 200) {
                dispatch({ type: 'UPDATE_LANGUAGES_NAME', payload: editLanguagesNames.data?.data})
                toast.success(editLanguagesNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const languagesApprovedAndUnAprooved = async (languagesId) => {
        try {
            const approvedAndUnapprovedStatus = await languagesUpdateApprovedAndUnapproved(languagesId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_LANGUAGES_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }

    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
                return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved} statusId={val.data._id} handleApprovedAndUnAprooved={languagesApprovedAndUnAprooved}/> )
                }
        },
            { field: '_id', flex: 2, headerName: 'Action', cellRenderer: (val) => ( <EditButton name={val.data.name} statusId={val.data?._id} isoCode={val.data?.isoCode} hadnleEditName={setLanguagesValName} handleEditBtn={setLanguagesShow} />) }
        ];

    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>Languages</h3>
            </div>
            <AddButton formName="Languages" handleAddBtn={setAddLanguagesShow}  />
            <CustomTable colDefs={colDefs} rowData={languagesInfo} />
            <AddMasterDataWithCountryCode formName="Languages" addMasterData={addLanguageHandle} showAddForm={showAddLanguages} setShowAddForm={setAddLanguagesShow} />
            <EditMasterFormWithCountryCode formName="Languages" editMasterDataName={languagesValName} editMasterData={editLanguagesHandle} showEditForm={showLanguages} setShowEditForm={setLanguagesShow}/>
        </React.Fragment>
    )
};
export default Languages;